module.exports = __webpack_public_path__ + "img/3.6fd643f7.jpg";